













































import { Component, Prop, Vue } from 'vue-property-decorator';
import { MenuEntry } from '../../../build/swagger-code-extranet-api-definition/models';

@Component
export default class MenuItem extends Vue {
  @Prop({ required: true }) public entry: MenuEntry;
}
